import { Component, OnInit } from '@angular/core';
import { SAService } from '../sa-service.service';
import { Kasse } from '../kasse';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { ISAKasse } from './../../assets/sa_kasse_model';
@Component({
  selector: 'app-schlossanger',
  templateUrl: './app-schlossanger.component.html',
  styleUrls: ['./app-schlossanger.component.scss']
})
export class AppSchlossangerComponent {
  //implements OnInit {
  public myPassword="";//: FormGroup;

  newInput: ISAKasse;


  hidecode = false;
  hide = true;

  title ="SA-Kasse";
 
  KassenP: Kasse[];
  dataSource: MatTableDataSource<Kasse>;
  selection = new SelectionModel<Kasse>(true, []);
total;

   einahmen_sum: number;
   ausgaben_sum: number;
   bilanz: number;

 // kassenp: Array<KassenModel>;
private value;
  displayedColumns: string[] = ["name", "date", "einnahmen", "ausgaben", "note"];

    constructor(private SaKasse: SAService) { }

  ngOnInit(): void {

    this.getKasse();

 
  }

  getKasse():void
  {

    
    let init: number;
    init=0;

    this.SaKasse.getKasse()
    .subscribe((data)=> {this.KassenP=data; console.log(this.KassenP); 
      this.einahmen_sum=data.reduce<number>(
      (accumulator: number, currentValue) =>  
    accumulator + Number(currentValue.einnahmen), init);

    this.ausgaben_sum=data.reduce<number>(
      (accumulator: number, currentValue) =>  
    accumulator + Number(currentValue.ausgaben), init);

    this.bilanz= this.einahmen_sum-this.ausgaben_sum;
  
    console.log(this.einahmen_sum);
    console.log(this.ausgaben_sum);

      })



  }

  onPasswordInput() {

    if (this.myPassword=="imnat239")
    {
      this.hidecode = true;
    }
    else
    {
      this.hidecode=false;
    }


  }

  isAllSelected() {
    if (this.dataSource === undefined) return false;

    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  checkboxLabel(row?: Kasse): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.id + 1
    }`;
  }

  onNewEntry(): void {

    alert('2e' + this.newInput);
    // Process checkout data here
   // this.items = this.cartService.clearCart();
   // console.warn('Your order has been submitted', this.checkoutForm.value);
   // this.checkoutForm.reset();
  }

    //  this.einahmen_sum()
     // this.einahmen_sum=KassenP.reduce((accumulator, current) => accumulator + current.einnahmen , 0)});



    //, this.einahmen_sum=this.getSum(2))
 //his.einahmen_sum=this.getSum(this.KassenP);




  //  var total;
   // this.value=data;
   // for(let j=0;j<data.length;j++){   
    //  total+= this.value[j].einnahmen  
    //  console.log(total)  
//return total; 
    
}
  
 

  

  


